var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"about-nav"},_vm._l((_vm.navList),function(item){return _c('li',{key:item.key,staticClass:"shou",class:{
      'about-active': item.key == _vm.navActive,
    },on:{"click":function($event){return _vm.navClick(item)}}},[_c('span',{staticClass:"title-span"},[_vm._v(" "+_vm._s(item.label)+" ")]),_c('span',{staticClass:"desc-span"},[_vm._v(" "+_vm._s(item.desc)+" ")])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }